export default __webpack_public_path__ + "imgs/3bbd4e4f110af0feafb33a49b9a6aace.png";